import { ReactComponent as NotAnalysisSvg } from 'assets/notAnalysis.svg';
import Button from "components/button/button";
import { AppAction, AppContext } from "helpers/context";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import TryAgain from "components/tryAgain/tryAgain";
import ClimateRiskModal from "../climate-risk-modal/climate-risk-modal";

export default function AnalysisResults() {
    const [context, dispatch] = useContext(AppContext);
    const [t] = useTranslation();

    const handleRetry = () => {
        dispatch({ type: AppAction.setTryAgainType, payload: "analyse" });
    }

    const selectedLayers = context.singleAnalysisSelectedLayers || [];
    const selectedClimateCategories = [
        selectedLayers[1]?.length ? context.batchId : undefined,
        selectedLayers[2]?.length ? context.futureHazardBatchId : undefined,
        selectedLayers[3]?.length ? context.crsComponentBatchId : undefined,
    ].filter((status) => status !== undefined) as string[];

    const hasSelectedClimateCategory = selectedClimateCategories.length > 0;
    const hasResolvedBatchId = selectedClimateCategories.some(
        (status) => status !== "running" && status !== "error"
    );
    const hasErrorStatus = selectedClimateCategories.some((status) => status === "error");
    const hasRunningStatus = selectedClimateCategories.some((status) => status === "running");

    if (!hasSelectedClimateCategory) {
        return (
            <div className="text-center">
                <NotAnalysisSvg className="w-[60px] h-[60px] mx-auto  mb-4" />
                <div style={{ color: "var(--gray-text)" }}>{t("single.notAnalysis")}</div>
            </div>);
    }

    if (hasErrorStatus) {
        return (<TryAgain handleRetry={handleRetry} />);
    }

    if (hasResolvedBatchId) {
        const climateModalOpeen = () => {
            dispatch({ type: AppAction.setClimateRiskModal, payload: true });
        }

        return (
            <>
                <div className="text-xs text-center">
                    <Button onClick={climateModalOpeen}>{t("single.viewAnalysisResults")}</Button>
                </div>
                <ClimateRiskModal />
            </>
        );
    }

    if (hasRunningStatus) {
        return (
            <div className="text-center">
                <div className="loading loading-spinner loading-lg"></div>
                <div>{t("single.climateAlalyseLoadingContent")}</div>
            </div>);
    }

    return null;
}
